module.exports = __webpack_public_path__ + "e1f8b3272b48b8671849fea9d810c0e8.svg";